import { APP_PREFIX_PATH } from "configs/AppConfig";
import { useLocation } from "react-router-dom";

export const useRouteDetection = () => {
  const location = useLocation();

  // Define routes where the widget should be hidden
  const hiddenRoutes = [
    `${APP_PREFIX_PATH}/school-management/student/import-pose`,
    `${APP_PREFIX_PATH}/poses/`,
    `${APP_PREFIX_PATH}/profile/`,
    `${APP_PREFIX_PATH}/qr-code`,
  ];

  // Check if current route should hide the widget
  const shouldHideWidget = hiddenRoutes.some(
    (route) => location.pathname.includes(route) || location.pathname === route
  );

  return {
    currentPath: location.pathname,
    shouldHideWidget,
    isImportPage: shouldHideWidget,
  };
};
